import { createContext, useContext } from 'react';
import type { VariantPickerModel } from 'autogen/swagger/all';
import { createStore, useStore } from 'zustand';

type VariantPickerStoreProps = {
    model: VariantPickerModel;
};

type VariantPickerState = VariantPickerStoreProps & {
    setModel: (id: VariantPickerModel) => void;
};

export const createVariantPickerStore = (initProps: VariantPickerStoreProps) => {
    return createStore<VariantPickerState>()((set) => ({
        ...initProps,
        setModel: (model) => set((state) => ({ ...state, model }))
    }));
};

export type VariantPickerStore = ReturnType<typeof createVariantPickerStore>;

export const VariantPickerContext = createContext<VariantPickerStore | null>(null);

export function useVariantPickerStore() {
    const store = useContext(VariantPickerContext);
    if (!store) throw new Error('Missing VariantPickerContext.Provider in the tree');
    return useStore(store);
}
